import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const MonitorIcon: React.FC<IconProps> = props => (
  <BaseIcon viewboxSize="xl" {...props}>
    <path d="M20 25a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2h3v-3H5a1 1 0 0 1-.995-.898L4 21V6a1 1 0 0 1 1-1h22l.102.005A1 1 0 0 1 28 6v15a1 1 0 0 1-.898.995L27 22H17v3h3ZM6 20h20V7H6v13Z" />
  </BaseIcon>
);
